module.exports = __webpack_public_path__ + "static/media/covered_car.ecdd9965.jpg";